import React, {useEffect, useState} from 'react';
import {Search} from "react-feather";
import UserAvatar from "../Item/UserAvatar";

const AccountsFilter = ({accounts = [], selectedIds = [], onSelectedIdsChange, skipPrimary = false}) => {
    const [inputValue, setInputValue] = useState('');
    const [displayAccounts, setDisplayAccounts] = useState(accounts);
    const [selectedAccountIds, setSelectedAccountIds] = useState([]);

    useEffect(() => {
        if (selectedIds.length > 0) {
            setSelectedAccountIds(selectedIds);
        } else if (!skipPrimary) {
            const primaryAccount = accounts.find((account) => account.is_primary);
            if (primaryAccount) {
                setSelectedAccountIds([primaryAccount.id]);
            }
        }
        setDisplayAccounts(accounts);
    }, [accounts, selectedIds, skipPrimary]);

    function handleInputChange(event) {
        const value = event.target.value;
        setInputValue(value);

        const filteredAccounts = accounts.filter((account) => {
            const fullName = `${account.first_name} ${account.last_name}`.toLowerCase();
            return fullName.includes(value.toLowerCase());
        });

        setDisplayAccounts(filteredAccounts);
    }

    function vendorAccountSelect(account) {
        const updatedSelectedAccountIds = selectedAccountIds.includes(account.id) ?
            selectedAccountIds.filter((id) => id !== account.id) :
            [...selectedAccountIds, account.id];

        setSelectedAccountIds(updatedSelectedAccountIds);
        onSelectedIdsChange(updatedSelectedAccountIds);
    }

    return (<div className="sl-flex sl-flex-col sl-gap-2 sl-align-stretch">
        <div className="sl-input sl-border-1 sl-shadow-xs sl-rounded-lg sl-w-fill-available sl-flex">
            <Search
                className="sl-icon sl-icon-leading sl-place-self-center sl-h-5 sl-w-5 sl-ml-2"/>
            <input
                value={inputValue}
                onChange={handleInputChange}
                className="sl-input sl-border-none sl-font sl-text-md sl-font sl-font-normal sl-text-md sl-p-0 sl-m-0 sl-h-11 sl-w-fill-available"
                type="text" placeholder="Search"/>
        </div>

        {displayAccounts && <div
            className="sl-flex sl-flex-col sl-gap-2 sl-mb-6">
            {displayAccounts.map((account, index) => (
                <label
                    htmlFor={account.id}
                    key={index}
                    rel={account.id}
                    className={`${selectedAccountIds.includes(account.id) ? 'checked' : ''} sl-cursor-pointer sl-checkbox-radio-label sl-mb-0 sl-px-4 sl-py-2 sl-flex sl-border-all sl-rounded-lg sl-w-fill-available sl-justify-space-between sl-align-center`}>
                    <div className="sl-flex sl-avatar-label-group sl-justify-start sl-align-center">
                        <UserAvatar userData={account} isAvatarActive={false}
                                    avatarClass="sl-h-8 sl-w-8 sl-inline-flex"/>
                        <div className="sl-font sl-text-md sl-font-medium sl-text-gray-700 sl-mr-1">
                            {account.first_name} {account.last_name}
                        </div>
                        {account.is_primary &&
                            <div className="sl-badge sl-badge-sm sl-badge-gray sl-rounded-2xl">
                                Primary Contact</div>}
                    </div>
                    <input id={account.id}
                           onChange={() => vendorAccountSelect(account)}
                           checked={selectedAccountIds.includes(account.id)}
                           className="sl-checkbox sl-checkbox-radio sl-checkbox-circle sl-checkbox-sm sl-m-0"
                           type="checkbox" value={account.id}/>
                </label>))}
        </div>}

        {displayAccounts.length === 0 && (<div className="sl-loader sl-m-auto"/>)}
    </div>);
};

export default AccountsFilter;
